module.exports = __webpack_public_path__ + "static/media/compare-vehicle-screenshot.9da592e2.png";